// Formats locale-aware pour les ecrans affichages (E1d). Reutilise formatDateOnly /
// formatDate / isDeadlineSoon de dates.ts equipes (source unique, E1b) — pas de
// reduplication du helper d'echeance.

import type { PostingStatus } from '../../hooks/usePostings';
import type { StatusBadgeProps } from '@gs/ui';

export { formatDate, formatDateOnly, isDeadlineSoon } from '../equipes/dates';

/** Variante de badge par statut (open = poste ouvert, filled = pourvu, cancelled = annule). */
export const POSTING_STATUS_BADGE: Record<PostingStatus, StatusBadgeProps['variant']> = {
  open: 'success',
  filled: 'info',
  cancelled: 'neutral',
};

/** Taille de fichier lisible (« 12,3 Ko » / « 1,4 Mo ») — locale-aware, 1 decimale. */
export function formatFileSize(locale: string, bytes: number | null): string | null {
  if (bytes == null || bytes < 0) return null;
  const intl = locale.startsWith('en') ? 'en-CA' : 'fr-CA';
  const nf = new Intl.NumberFormat(intl, { minimumFractionDigits: 0, maximumFractionDigits: 1 });
  if (bytes < 1024) return `${nf.format(bytes)} ${locale.startsWith('en') ? 'B' : 'o'}`;
  if (bytes < 1024 * 1024) return `${nf.format(bytes / 1024)} ${locale.startsWith('en') ? 'KB' : 'Ko'}`;
  return `${nf.format(bytes / (1024 * 1024))} ${locale.startsWith('en') ? 'MB' : 'Mo'}`;
}
